import React from 'react'
import Row from '@amzn/meridian/row'
import Column from '@amzn/meridian/column'
import Text from '@amzn/meridian/text'
import Badge from '@amzn/meridian/badge'
import Divider from '@amzn/meridian/divider'
import storeIcon from '../../../images/store_icon.svg'
import { STORE_ICON_ALT } from '../constants'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import './StoreIcon.scss'

interface IStoreNotificationHeaderProps {
    storeName: string
    notificationCount?: number
}

export const StoreNotificationHeader: React.FC<IStoreNotificationHeaderProps> = ({
    storeName,
    notificationCount,
}) => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
        <Column spacing="300">
            <Row spacing="200" alignmentVertical="center" alignmentHorizontal="justify">
                <Row spacing="300" alignmentVertical="center">
                    <img src={storeIcon} alt={t(bundle, STORE_ICON_ALT)} className="store-icon" />
                    <Text type="h200">{storeName}</Text>
                </Row>
                {notificationCount !== undefined && <Badge type="theme" value={notificationCount} />}
            </Row>
            <Divider />
        </Column>
    )
}
